import { createFileRoute, redirect } from '@tanstack/react-router'
import { vtoBulkJobItem } from '@/lib/queries/vto-bulk-job-items'
import { vtoBulkJob } from '@/lib/queries/vto-bulk-jobs'
import { VtoBulkJobDetailPage } from '@/features/workspaces/vto/components/vto-bulk-job-detail-page'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/vto/$jobId'
)({
  loader: async ({ context, params }) => {
    const [job] = await Promise.all([
      context.queryClient.query({
        ...vtoBulkJob.findOne(params.jobId),
        staleTime: 'static',
      }),
      context.queryClient.query({
        ...vtoBulkJobItem.findManyByJob(params.jobId),
        staleTime: 'static',
      }),
    ])

    if (!job || job.workspace_id !== params.workspaceId) {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId/bulk-jobs',
        params: { orgId: params.orgId, workspaceId: params.workspaceId },
        replace: true,
      })
    }
  },
  component: VtoBulkJobDetailPage,
})
